module.exports = __webpack_public_path__ + "img/5.2.TN.8209485c.png";